import LogoNeteller from "app/components/Logos/LogoNeteller";
import { getRoutePathForView } from "app/helpers/routerPathHelper";
import store from "app/store/store";
import { UserType } from "app/types/userType";
import { useState } from "react";
import cookie from "react-cookies";
import type { IntlShape } from "react-intl";
import { defineMessages, injectIntl } from "react-intl";
import { Route, Switch, useHistory } from "react-router-dom";
import * as netellerAPI from "../../../../api/netellerApi";
import Modal from "../../../../components/Modal/Modal";
import ManageFundingLogoHeader from "../../components/ManageFundingLogoHeader/ManageFundingLogoHeader";
import FormSubmittedScreen from "../FormSubmittedScreen/FormSubmittedScreen";
import NetellerFundingContent from "./components/NetellerFundingContent/NetellerFundingContent";
import "./NetellerFundingScreenDesktop.scss";
import "./NetellerFundingScreenMobile.scss";

export const TabTypes = {
  DEPOSIT: "DEPOSIT",
  WITHDRAW: "WITHDRAW",
};

function NetellerFundingScreen(props: { intl: IntlShape; user: UserType }) {
  const history = useHistory();
  const { intl, user } = props;
  const [tab, setTabValue] = useState(TabTypes.DEPOSIT);
  const [withdrawalEmail, setWithdrawalEmail] = useState("");
  const [amount, setAmount] = useState("");
  const [amountError, setAmountError] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [otherError, setOtherError] = useState("");
  const [iFrameUrl, setiFrameUrl] = useState("");
  const [iFrameActive, setIFrameActive] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [success, setSuccess] = useState(false);
  const [windowOpen, setWindowOpen] = useState(false);

  const deposit = () => {
    netellerAPI
      .depositFunds(amount, email)
      .then(resp => {
        console.log("depositFunds resp: ", resp);

        cookie.save("internalId", resp.data.internalId || "", {
          path: "/",
        });
        setFormSubmitted(false);
        setSuccess(false);
        setWindowOpen(true);
        // Make backwards compatible with older flow (without iFrame authorization)
        if (resp.data.href) {
          window.open(resp.data.href, "_parent");
        } else {
          setSuccess(true);
        }
        setFormSubmitted(false);
        setWindowOpen(true);
      })
      .catch(error => {
        console.log("error: ", error);
        if (error.response) {
          const errorData = error.response.data.errors;
          handleErrors(errorData);
          setFormSubmitted(false);
        }
      });
  };

  const withdraw = () => {
    netellerAPI
      .withdrawFunds(amount, withdrawalEmail)
      .then(resp => {
        setFormSubmitted(false);
        setSuccess(true);
        const path = getRoutePathForView();
        history.push(`${path}neteller/withdrawSuccess`);
      })
      .catch(error => {
        const errorData = error.response.data.errors;
        handleErrors(errorData);
        setFormSubmitted(false);
      });
  };

  const closeModal = () => setIFrameActive(false);

  const handleChange = (id: string, value: string) => {
    if (id === "email") {
      setEmail(value);
    }
    if (id === "amount") {
      setAmount(value);
    }

    if (id === "withdrawalEmail") {
      setWithdrawalEmail(value);
    }
  };

  const handleErrors = errorData => {
    let _amountError = "";
    let _emailError = "";
    let _otherError = "";
    console.log("errorData: ", errorData);
    if (errorData.length > 0) {
      errorData.forEach(error => {
        if (error.messages) {
          if (error.field === "amount") {
            _amountError = error.messages[0];
          } else if (error.field === "email") {
            _emailError = error.messages[0];
          } else {
            _otherError = error.messages[0];
          }
        } else if (error.detail) {
          _otherError = error.detail;
        }
      });
    }
    setAmountError(_amountError);
    setEmailError(_emailError);
    setOtherError(_otherError);
  };

  const setTab = (tabType: string) => {
    if (tab === tabType) {
      return null;
    }
    setAmountError("");
    setEmailError("");
    setOtherError("");
    setTabValue(tabType);
  };

  const getTabs = () => {
    return [
      {
        title: intl.formatMessage({
          id: "cashier-deposit",
        }),
        callback: () => setTab(TabTypes.DEPOSIT),
        isActive: tab === TabTypes.DEPOSIT,
        id: "cashier-deposit",
      },
      {
        //translate titles
        title: intl.formatMessage({
          id: "cashier-withdraw",
        }),
        callback: () => setTab(TabTypes.WITHDRAW),
        isActive: tab === TabTypes.WITHDRAW,
        id: "cashier-withdraw",
      },
    ];
  };
  const newTransaction = () => {
    setFormSubmitted(false);
    setSuccess(false);
  };

  const onSubmit = e => {
    e.preventDefault();
    setFormSubmitted(true);

    if (tab === TabTypes.DEPOSIT) {
      deposit();
    } else if (tab === TabTypes.WITHDRAW) {
      withdraw();
    }
  };

  // Functions for telling the api whether success/fail
  const verifyDeposit = () => {
    const internalIdFromCookie = cookie.load("internalId");
    console.log("verifyDeposit internalIdFromCookie: ", internalIdFromCookie);
    if (internalIdFromCookie) {
      netellerAPI
        .verifiyDeposit(internalIdFromCookie)
        .then(() => {})
        .catch(error => {
          console.log("error: ", error);
          throw error;
        });
    }
  };

  const rejectDeposit = () => {
    const idFromStore: string = store.getState().cashierModel.internalId;
    console.log("rejectDeposit idFromStore: ", idFromStore);
    netellerAPI
      .rejectDeposit(idFromStore)
      .then(() => {})
      .catch(error => {
        console.log("error: ", error);
        throw error;
      });
  };

  const I18n = defineMessages({
    accountId: {
      id: "cashier-accountid",
    },
    amount: {
      id: "cashier-amount",
    },
    email: {
      id: "settings-email",
    },
  });

  const path = getRoutePathForView();

  const netellerPath = `${path}neteller`;
  console.log("netellerPath: ", netellerPath);
  return (
    <Switch>
      <Route
        exact
        path={netellerPath}
        render={() => (
          <div className="neteller-funding">
            <ManageFundingLogoHeader
              history={history}
              getTabs={getTabs()}
              logo={<LogoNeteller />}
            />
            <Modal
              modalOpen={iFrameActive}
              closeModal={closeModal}
              contentLabel="Neteller"
              cancelButton
              cancelButtonText="Close"
              className="neteller-modal"
            >
              <div className="neteller-funding__iframe">
                <iframe
                  title="Neteller Authentication"
                  src={iFrameUrl}
                  frameBorder="0"
                />
              </div>
            </Modal>
            <NetellerFundingContent
              onSubmit={onSubmit}
              tab={tab}
              I18n={I18n}
              handleChange={handleChange}
              emailError={emailError}
              amountError={amountError}
              otherError={otherError}
              formSubmitted={formSubmitted}
              user={user}
            />
          </div>
        )}
      />
      <Route
        path={`${netellerPath}/success/`}
        render={() => (
          <FormSubmittedScreen
            user={user}
            verified={user["verifiedStatus"]}
            selectedTab={tab}
            newTransaction={history.goBack}
            onSuccess={verifyDeposit}
          />
        )}
      />
      <Route
        path={`${netellerPath}/error/`}
        render={() => (
          <FormSubmittedScreen
            verified={user["verifiedStatus"]}
            selectedTab={tab}
            newTransaction={history.goBack}
            error={true}
            onError={rejectDeposit}
          />
        )}
      />
      <Route
        path={`${netellerPath}/withdrawSuccess/`}
        render={() => (
          <FormSubmittedScreen
            verified={user["verifiedStatus"]}
            selectedTab={TabTypes.WITHDRAW}
            newTransaction={history.goBack}
            onSuccess={verifyDeposit}
          />
        )}
      />
    </Switch>
  );
}

export default injectIntl(NetellerFundingScreen);
